import { Fab as MuiFab, FabTypeMap as MuiFabTypeMap } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';
import React from 'react';
import {
  ExtendTypeMap,
  forwardRefToOverridableComponent,
} from 'src/utils/forwardRefToOverridableComponent';

declare module '@mui/material/Fab' {
  interface FabPropsSizeOverrides {
    xsmall: true;
  }
  interface FabClasses {
    /** Styles applied to the root element if `size="xsmall"`. */
    sizeXsmall: string;
  }
}

type FabOwnProps = {
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */
  size?: 'xsmall' | 'small' | 'large';
};

export type FabTypeMap<
  AdditionalProps = unknown,
  RootComponent extends React.ElementType = MuiFabTypeMap['defaultComponent']
> = ExtendTypeMap<
  {
    props: Omit<
      MuiFabTypeMap['props'],
      | 'color'
      | 'disableFocusRipple'
      | 'disableRipple'
      | 'action'
      | 'centerRipple'
      | 'disableTouchRipple'
      | 'focusRipple'
      | 'focusVisibleClassName'
      | 'TouchRippleProps'
      | 'size'
      | 'touchRippleRef'
    >;
    defaultComponent: MuiFabTypeMap['defaultComponent'];
  },
  AdditionalProps & FabOwnProps,
  RootComponent
>;

export type FabProps<
  RootComponent extends React.ElementType = MuiFabTypeMap['defaultComponent'],
  AdditionalProps = unknown
> = OverrideProps<FabTypeMap<AdditionalProps, RootComponent>, RootComponent>;

export const Fab = forwardRefToOverridableComponent<FabTypeMap, FabProps>(
  function Fab(props, ref) {
    // @ts-expect-error color is intentionally not exposed to consumers
    return <MuiFab ref={ref} color="primary" {...props} />;
  }
);

export default Fab;
